if (!customElements.get("price-element")) {
  class PriceElement extends HTMLElement {
    constructor() {
      super();
      this.selectedType = "corporate"; // Default value
    }

    connectedCallback() {
      if (!document.querySelector("client-type-selector")) {
        return;
      }
      this.getLocalStorage(); // Update method to retrieve the selected type from local storage
      this.setPrices();
    }

    updatePrice() {
      const currentType = this.selectedType; // Store current type
      this.getLocalStorage(); // Retrieve updated type
      if (currentType !== this.selectedType) {
        this.setPrices(); // Update prices if the type has changed
      }
    }

    getLocalStorage() {
      // Retrieve the selected customer type from local storage
      this.selectedType = localStorage.getItem("selectedCustomerType") || "corporate";
    }

    setPrices() {
      const privatePriceElements = this.querySelectorAll(".js-private-price");
      const corporatePriceElements = this.querySelectorAll(".js-corporate-price");

      // Show or hide prices based on the selected type
      if (this.selectedType === "private") {
        privatePriceElements.forEach((element) => {
          element.classList.remove("hidden");
        });
        corporatePriceElements.forEach((element) => {
          element.classList.add("hidden");
        });
      } else {
        privatePriceElements.forEach((element) => {
          element.classList.add("hidden");
        });
        corporatePriceElements.forEach((element) => {
          element.classList.remove("hidden");
        });
      }
    }
  }

  customElements.define("price-element", PriceElement);
}
